import axios from "axios";

const url = process.env.REACT_APP_BACK_END_URL;

//Get group details by group subdomain 
export const getGroupDetailsData = async (subdomain) => {
    return axios.get(url + '/web/group/' + subdomain)
}

export const getVersionDetailsData = () => {
    return axios.get(url + '/web/version' )
}

// User registration
export const registerUser = async (userData) => {
    return axios.post(url + '/client/users/register', userData)
}

// Payment APIs
export const getSubscriptionPlans = async () => {
    return axios.get(url + '/client/payment/get_subscription_plans')
}

export const createPaymentOrder = async (orderData) => {
    return axios.post(url + '/client/payment/create_payment_order', orderData)
}

export const verifyPayment = async (paymentData) => {
    return axios.post(url + '/client/payment/verify_payment', paymentData)
}

// SMS OTP APIs
export const sendSMSOTP = async (phoneData) => {
    return axios.post(url + '/web/otp/send_sms_otp', phoneData)
}

export const verifySMSOTP = async (otpData) => {
    return axios.post(url + '/web/otp/verify_sms_otp', otpData)
}

export const resendSMSOTP = async (phoneData) => {
    return axios.post(url + '/web/otp/resend_sms_otp', phoneData)
}

// Email OTP APIs
export const sendEmailOTP = async (emailData) => {
    return axios.post(url + '/web/otp/send_email_otp', emailData)
}

export const verifyEmailOTP = async (otpData) => {
    return axios.post(url + '/web/otp/verify_email_otp', otpData)
}

export const resendEmailOTP = async (emailData) => {
    return axios.post(url + '/web/otp/resend_email_otp', emailData)
}

// Signup status checking
export const checkSignupStatus = async (email) => {
    return axios.post(url + '/client/users/check_signup_status', { email })
}

// Mobile registration (using main users route)
export const registerUserMobile = async (userData) => {    
    return axios.post(url + '/client/users/register', userData)
}

// Get offering by offering_id
export const getOfferingByOfferingId = async (offering_id) => {
    return axios.get(url + '/web/offering/' + offering_id)
}

